import React from "react";
import Overview from "./Overview";
import PDFResultCard from "./PDFResultCard";
import Figures from "./Figures";
import DetailGrid from "../components/DetailGrid";
import InterestArea from "./InterestArea";
import Books from "./Books";
import QuoteBlock from "./QuoteBlock";
import { detailedResultState } from "../../../utils/recoil";
import { useRecoilState } from "recoil";
import { useTranslation } from "react-i18next";

const Introduction = ({ resultOverride }) => {
  const [data] = useRecoilState(detailedResultState);
  const { t } = useTranslation("result")
  return (
    <>
      <Overview />
      <PDFResultCard resultOverride={resultOverride} />
      <Figures />
      <DetailGrid
        number={"4"}
        title={t("grid1")}
        data={data?.strength_overview}
      />
      <InterestArea />
      <QuoteBlock text={data?.interests?.description} />
      <DetailGrid number={"6"} title={t("grid2")} data={data?.workfit} />
      <Books />
      <DetailGrid number={"8"} title={t("grid3")} data={data?.paths} />
    </>
  );
};

export default Introduction;
